import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

import { COLORS } from '../../../configs/colors';

export const StyledBox = styled(Box)`
  & .super-app.negative {
    background-color: #E0B73C;
  }

  & .super-app.positive {
    background-color: ${COLORS.CardBackground},
  }
`;

export const AdvanceLiveSearchWrapper = styled('div')`
  width: 75%;
`;

export const ImportWrapper = styled('div')`
  width: 25%;
  display: flex;
  flex-direction: column;
`;
